import React, { useState } from "react";

const SectionOne = () => {
  const [bgImage, setBgImage] = useState("./assets/bg.jpg");
  return (
    <div
      className="relative"
      style={{
        backgroundImage: `url('${bgImage}')`,
        backgroundPosition: "center 100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        transition: "background-image 1s ease-out",
        // backgroundColor: '#142528',
      }}
    >
      {/* Main content */}
      <div className="flex flex-col gap-5 md:gap-8 lg:gap-7 xl:gap-8 justify-center items-center px-6 py-10 md:py-20 xl:py-32 z-0 ">
        <h1 className="text-center text-2xl md:text-6xl lg:text-6xl xl:text-7xl text-white font-bold leading-snug tracking-wider font-montserrat">
          Empowering <span className="text-[#32AE4C]">Growth</span>{" "}
          <br className="hidden md:block" /> for African Businesses
        </h1>
        <p className="text-center text-white text-xs md:text-2xl lg:text-base xl:text-lg font-inter">
          All-in-one financial OS for your business. Send invoices, track
          expenses, run payroll, save in stronger currencies, and stay
          audit-ready with structured accounting.
        </p>
        <div className="flex justify-center  mt-2 md:mt-5 gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=com.vantapp.vantbussiness"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={"./assets/goggle.svg"}
              className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] lg:h-[50px]"
              alt="playstore_img"
            />
          </a>

          <a
            href="https://apps.apple.com/app/vant-business/id6744277881"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={"./assets/app.svg"}
              className="w-[130px]  h-[36px] md:w-[150px] lg:w-[170px] md:h-[45px] lg:h-[50px]"
              alt="appstore_img"
            />
          </a>
        </div>
      </div>

      {/* Bottom logo */}
      <div className="flex justify-center items-center mt-8 md:mt-2 lg:mt-0">
        <img
          src={"./assets/dashboard.png"}
          className="w-[80%] h-auto animate__fadeInUp animate__animated  animate__delay-1s animate__slower"
          alt="vant_logo"
        />
      </div>
    </div>
  );
};

export default SectionOne;